/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import { T_SERVER_ERROR_PREFIX } from '../const'

export default class DataIntegrityViolationException {

    serialize(context, error, _json) {
        error.messages.unshift(error.message)
        error.message = `${T_SERVER_ERROR_PREFIX}SPRING_DATA_INTEGRITY_VIOLATION`
    }
}
